import request from '@/utils/request'

export function getList (filters = {}, pagination = {}) {
  return request({
    url: '/protocol_has_site',
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination),
      // 'x-query-debug': true
    }
  })
}

export function getDetail (protocol_id, site_id) {
  return request({
    url: '/protocol_has_site/' + protocol_id + '/' + site_id,
    method: 'get'
  })
}

export function upsert (data) {
  var method = 'post'
  var url = '/protocol_has_site'
  if (data.id) {
    method = 'put'
    url = '/protocol_has_site/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}

export function remove (protocol_id, site_id) {
  return request({
    url: '/protocol_has_site/' + protocol_id + '/' + site_id,
    method: 'delete'
  })
}